<template>
  <div class="container">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <div class="Requirement">
      <div class="requirement-detail-box">
        <div class="requirement-detail">
          <div class="breadcrumb_box">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/circle' }">社区</el-breadcrumb-item>
              <el-breadcrumb-item>提交作业</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="requirement-main">
            <div class="requirement-work-title">作业名称：{{des.title}}</div>
            <div class="requirement-course-title">课程名称：{{des.title}}</div>
            <div class="requirement-main-box">
              <div class="requirement-main-teacher">
                <div class="head-image-box">
                  <img :src="des.teacher_image" alt="">
                </div>
                <div class="head-image-box2">
                  <img src="https://www.dapengjiaoyu.cn/dapeng/img/266362e.1660726626187.png" class="main-info-icon"
                    alt="">
                  <p class="main-info-nickname">{{des.teacher_name}}</p>
                </div>
              </div>
              <div class="requirement-main-time">
                <p>授课时间：{{des.create_time}}</p>
                <P>截止时间：{{des.end_time}}</P>
              </div>
            </div>
            <div class="requirement-content">
              <div class="requirement-content-title">作业要求：</div>
              <div class="requirement-content-msg">{{des.content}}</div>
            </div>
          </div>
          <div class="requirement-img" v-if="des.images">
            <img :src="des.images" alt="">
          </div>
          <div class="requirement-media" v-if="des.media">
            <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
              :options="playerOptions">
            </video-player>
          </div>
          <!-- <div class="student-homework">
            <div class="student-homework-title">同学作业</div>
            <div class="homework-lists">
              <div class="list-img-box">
                <div class="less-than-four">
                  <div class="homework-lists_flex">
                    <div class="less-than-four-img">
                      <img
                        src="https://image.dapengjiaoyu.com/2022-08-23/kd3shvywet/2286521661_SDU=.jpg?x-oss-process=style/400x400lb"
                        alt="">
                    </div>
                    <div class="less-than-four-content">
                      <div class="user-content">
                        <div class="head-image-box">
                          <img src="	https://image.dapengjiaoyu.com/images/avatars/38avatar.jpg" alt="">
                        </div>
                        <div class="user-content-bottom">
                          <p>林书峰</p>
                          <p> 1小时前</p>
                        </div>
                      </div>
                      <div class="page-detail-card ">
                        <span class="card-work-link">
                          <i class="work-link-icon"></i>
                          <span class="card-work-link-msg">芸书2022期8.23---《一心一意》隶书曹全碑</span>
                          <i class="work-link-to-icon"></i>
                        </span>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <div class="requirement-submitCount">
          <p class="submitCounts">{{ des.list_count }}</p>
          <p>已提交作业（份）</p>
          <p class="publishHomeworks" @click="open = true;progress = 0">发布作业</p>
        </div>
      </div>
    </div>

    <!-- 发布弹窗 -->
    <el-dialog title="提交作业" v-if="open" :visible.sync="open" width="700px" append-to-body class="adddDialog"
      @open="$refs.formSX.clearValidate()" :before-close="reset">
      <el-form ref="formSX" :model="form" label-width="132px" label-position="top">
        <el-form-item label="作业标题：">
          <el-input v-model="form.title" class="textareaadd"></el-input>
        </el-form-item>
        <el-form-item label="想法描述：">
          <el-input type="textarea" v-model="form.content" class="textareaadd"></el-input>
        </el-form-item>
        <el-form-item label="上传图集/视频">
          <el-upload :auto-upload="false" :on-change="handleChange" ref="upload" list-type="picture-card"
            :on-remove="handleRemove">
          </el-upload>
        </el-form-item>
        <el-progress :percentage="progress"></el-progress>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">提 交</el-button>
        <el-button type="info" @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>
<script>
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  export default {
    name: 'Publish',
    components: {
      Menu,
      Footer
    },
    data() {
      return {
        msg: 111,
        open: false,
        des: {},
        progress: 0,
        form: {
          title: "",
          content: "",
          username: "",
          type: 3,
          type_id: ""
        },
        fileList: [],
        playerOptions: {},
        ImageUrls: [],
        VideoeUrls: [],
        imgFlag: true,
        videoFlag: false
      }
    },
    created() {
      this.Requirement()
    },
    methods: {
      Requirement() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/homework/content', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            chapter_id: this.$route.query.id
          }
        }).then(res => {
          this.des = res.data.data
          this.form.type_id = res.data.data.id
          this.playerOptions = {
            playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
            autoplay: false, // 如果为true,浏览器准备好时开始回放
            muted: false, // 默认情况下将会消除任何音频。
            loop: false, // 是否视频一结束就重新开始。
            preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            language: 'zh-CN',
            aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
            sources: [{
              type: "video/mp4", // 类型
              src: res.data.data.media // url地址
            }],
            poster: '', // 封面地址
            notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
            controlBar: {
              timeDivider: true, // 当前时间和持续时间的分隔符
              durationDisplay: true, // 显示持续时间
              remainingTimeDisplay: false, // 是否显示剩余时间功能
              fullscreenToggle: true // 是否显示全屏按钮
            }
          }
        }).catch(err => {
          console.log(err)
        })
      },
      handleChange(file, fileList) {
        this.fileList = fileList;
      },
      // 资源上传
      uploadFile(file) {
        let token;
        this.$axios({
          method: 'post',
          url: '/api/index/qiNiuToken',
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          }
        }).then(res => {
          token = res.data.data;
          let config = {
            chunkSize: 100,
            concurrentRequestLimit: 10,
            useCdnDomain: true
          };
          let putExtra = {
            fname: "",
            params: {},
            mimeType: null
          };
          var _this = this;
          var year = new Date().getFullYear();
          var month = new Date().getMonth() + 1;
          var day = new Date().getDate();
          var filename = 'homework/' + year + '-' + month + '-' + day + '/' + file.uid + file.name;
          let subscription;
          // 调用sdk上传接口获得相应的observable，控制上传和暂停
          let observable = qiniu.upload(file.raw, filename, token, putExtra, config);
          let observer = {
            next(result) {
              _this.progress = result.total.percent
            },
            error(err) { //失败后
              alert(err.message);
            },
            complete(res) {
              let address = 'https://file.meikesheji.com/' + res.key;
              let str = res.key.split(".")[1]
              if (str == "mp4" || str == "mov" || str == "m4v" || str == "3gp" || str == "avi" || str == "dat" ||
                str ==
                "mkv" || str == "flv" || str == "vob" || str == "mpg" || str == "mpeg" || str == "mpe") {
                _this.VideoeUrls.push(address)
              } else {
                _this.ImageUrls.push(address);
              }
              let resCount = _this.ImageUrls.length + _this.VideoeUrls.length
              if (resCount == _this.fileList.length) {
                _this.confirmSubmit();
              }
            }
          }
          // 取消上传
          // subscription.unsubscribe();
          observable.subscribe(observer)
        })
      },

      submitForm() {
        // 首先提交资源
        if (!this.form.title || !this.form.content) {
          this.$message.error('请认真填写');
          return;
        }
        if (this.fileList.length == 0) {
          this.$message.error('请上传作业');
          return;
        }
        for (var i = 0; i < this.fileList.length; i++) {
          this.uploadFile(this.fileList[i]);
        }
      },
      confirmSubmit() {
        let form = this.form
        form.images = this.ImageUrls
        form.media = this.VideoeUrls
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/post/submit', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: form
        }).then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
            this.open = false
            this.$router.push({
              path: "/Publishlist"
            })
          } else {
            this.$message.error(res.data.msg);
            this.open = false
            this.reset()
          }
        }).catch(err => {
          console.log(err)
        })
      },
      cancel() {
        this.open = false
        this.reset()
      },
      reset() {
        this.form.title = '';
        this.form.content = '';
        this.open = false
      },
      handleRemove(file, fileList) {
        this.fileList = fileList;
      }
    },
  }
</script>
<style lang="scss" scoped>
  .adddDialog {
    /deep/ .el-button--primary {
      background: linear-gradient(159deg, #1cdc94, #FABE00) !important;
      box-shadow: 0 2px 8px 0 rgba(12, 182, 91, 0.4) !important;
      color: #fff !important;
    }

    /deep/ .el-dialog__header {
      font-size: 14px !important;
    }

    /deep/ .el-textarea__inner {
      width: 100%;
      height: 101px;
      background: #f7f7f7;
      border-radius: 10px;
      border: 1px solid #dcdcdc;
      padding: 14px 16px 16px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
      font-weight: 500;
      color: #18252c;
      line-height: 20px;
    }

    /deep/ .el-input__inner {
      width: 50%;
      background: #f7f7f7;
      border-radius: 10px;
      border: 1px solid #dcdcdc;
      padding: 14px 16px 16px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
      font-weight: 500;
      color: #18252c;
      line-height: 20px;
    }

    /deep/ .el-upload--picture-card {
      background: #f5f8f8;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABGCAYAAAB12zK5AAAC2UlEQVR4Xu2cv2sUQRzF5+2dRgUbwcLiMBaR5GbONCLaacC/QEysRI1oTGtpIWhp7Q+iRAvBSPInqGihFtqEmyELB6JNLMRKISSb7JMNUZIzbpiLd7Mh3+sOZvb7vp99b2ePGQ5KPmsIoAg8Zmdn9ywtLbFSqcyF1hMUiHNuIE3TO0qp/hUQ00qp67Va7XUoMMGA1Ov1IQDPSK7RAIAAhrTWkyGgBAESx/HexcXFzyT3rdc0gO9KqW5jzM9OQwkCxFp7iuSrvGbL5fLJvr6+N9sCiHNuJE3T+3nNArhqjBnbFkCstaMk7+Y1G0XRNa31AwGyQkCANFlBgAgQeYb88YA8VJviIEAESP7bgzhEHCIO8XrDlshIZCQyEhkvAhIZiYyXYWSVkchIZCQyXgQkMhIZL8NsiVVmZmbmcJqm50j2k9zl1aHnYAAHSeoNNqocyS+el/YaDiA7bTAdRdFEtVptZJOXtzKdc5eyjaN2g/BS29nBcwBGjTFPEMfxkSRJPiqldnRWQ7GqAVgolUpHUa/Xsz3WkWLJC6MGwL0MyDul1IkwEopVFcBbWGunSJ4plrRgaiYzIJdJPgwmoUCFoygaRnakyTn3guRAgbR1XAqAl1rr08vLrrV2J4CbJC+SPNBxNQELAvgKYJzkLWPMwl9HqhqNxv75+fndbdZ4nuTtDWrcAPC0nTq6urrmenp6vq2uEeqMmZwgWn0XtsRvmXZas/naAqSJiAARIPkBFIeIQ8QhXouUREYiI5GRyHgRkMhIZLwMI6uMREYiI5HxIiCRkch4GUZWGYmMREYi40WgabBzbjBN0+d514ii6KzWemozdVqZG2SjKo7jQ0mSfMoTXCqVuqvValuPVK1XPwiQTIi19jHJC/+AMl6r1YZbucObnRMMSPYfIkmSPFJKDa5uAsBEuVy+0tvb+2OzzbUyPxiQ32Kdc8eUUsez7yTfG2M+tNLI/5rzCxKRSWrxysTGAAAAAElFTkSuQmCC);
      background-size: 34px 35px;
      background-repeat: no-repeat;
      background-position: 50%;
      cursor: pointer;
    }
  }
</style>
<style scoped>
  .Requirement {
    padding: 0px;
    width: 1200px;
    margin: 0 auto 20px;
  }

  .requirement-detail-box {
    display: flex;
  }

  .requirement-detail {
    width: 780px;
    margin-left: 127px;
    margin-top: 32px;
    position: relative;
  }

  .requirement-submitCount {
    width: 247px;
    height: 218px;
    background: #f5f8f8;
    border-radius: 8px;
    position: -webkit-sticky;
    position: sticky;
    top: 103px;
    padding: 50px 0 24px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 500;
    color: #18252c;
    text-align: center;
    z-index: 99;
    margin-left: 20px;
  }

  .submitCounts {
    font-size: 28px;
  }

  .publishHomeworks {
    width: 195px;
    height: 40px;
    margin: 36px auto 0;
    line-height: 40px;
    background: linear-gradient(316deg, #FABE00, #1cdc94);
    border-radius: 6px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 500;
    color: #fff;
    text-align: center;
    cursor: pointer;
    position: relative;
  }

  .content_top {
    padding: 20px 0;
  }

  .requirement-main {
    padding-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;
    position: relative;
    text-align: left;
  }

  .requirement-work-title {
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 600;
    color: #18252c;
    margin-bottom: 16px;
  }

  .requirement-course-title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 500;
    color: #18252c;
    margin-bottom: 24px;
  }

  .requirement-main-box {
    display: flex;
    justify-content: space-between;
  }

  .requirement-main-teacher {
    margin-bottom: 23px;
  }

  .head-image-box {
    float: left;
  }

  .head-image-box2 {
    float: left;
  }

  .head-image-box img {
    height: 45px;
    width: 45px;
    border-radius: 50%;
    vertical-align: middle;
    -o-object-fit: cover;
    object-fit: cover;
    cursor: pointer;
  }

  .main-info-icon {
    margin-left: 8px;
  }

  .main-info-nickname {
    margin-left: 12px;
    margin-top: 5px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 600;
    color: #18252c;
  }

  .requirement-main-time {
    height: 61px;
    background: #fff8f1;
    border-radius: 6px;
    margin-top: -8px;
    padding: 8px 16px;
    box-sizing: border-box;
  }

  .requirement-main-time P {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 400;
    color: #36404a;
  }

  .requirement-content {
    width: 780px;
    background: #f5f8f8;
    border-radius: 6px;
    padding: 12px 16px;
    box-sizing: border-box;
    margin-bottom: 24px;
  }

  .requirement-content-title {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 600;
    color: #18252c;
    margin-bottom: 10px;
  }

  .requirement-content-msg {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
  }

  .requirement-img {
    width: 780px;
    height: 527px;
    border-radius: 8px;
    position: relative;
  }

  .requirement-img img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    -o-object-fit: cover;
    object-fit: cover;
    cursor: pointer;
  }

  .requirement-media {
    width: 780px;
    margin-top: 1.25rem;
    display: flex;
    flex-wrap: wrap;
  }

  .requirement-media .video-player {
    width: 100%;

  }

  .requirement-media .video-player:nth-child(2n) {
    margin-right: 0;
  }

  .student-homework,
  .homework-lists {
    margin: 20px 0;
  }

  .student-homework-title {
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 600;
    color: #1a3743;
    text-align: left;
  }

  .homework-lists_flex {
    position: relative;
    display: flex;
    height: 195px;
  }

  .less-than-four-img {
    position: relative;
    width: 260px;
    height: 195px;
    overflow: hidden;
    border-radius: 5px;
    cursor: pointer;
  }

  .less-than-four-img img {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .less-than-four-content {
    flex: 1;
    margin-left: 12px;
    position: relative;
    cursor: pointer;
  }

  .user-content {
    display: flex;
    position: relative;
  }

  .head-image-box img {
    height: 40px;
    width: 40px;
    border-radius: 50%;
  }

  .user-content-bottom {
    margin-left: 8px;
  }

  .user-content-bottom p {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 600;
    color: #18252c;
    line-height: 20px;
  }

  .page-detail-card {
    height: 24px;
    cursor: auto;
    text-align: left;
    margin-top: 15px;
  }

  .card-work-link {
    padding: 0 32px 0 26px;
    display: inline-block;
    height: 24px;
    line-height: 24px;
    background: #e6f7ee;
    border-radius: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 400;
    color: #FABE00;
    cursor: pointer;
    position: relative;
  }

  .work-link-icon {
    position: absolute;
    display: inline-block;
    transform: translateY(-50%);
    top: 50%;
    left: 8px;
    width: 14px;
    height: 14px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABjklEQVQ4T21SPUtcURA9E8iGgEWE+LFabqWFaJUyRQqbYCCNre8HaBMJBJ4gCkZDCGIjSrqQXoh1CsUP0MSgaIi/IFVkkUXd3XuO3H1737sGbzXM3DPnzJmx/vOVTYjPSG4L7vtVo/m1OvTuAtHrOpgZgeE1oOcShyGuW9+fZYI0iYAIif8ALv21+nKn1PuwYStyfNWu+ToMvLG+35+Ug9gChgZViI9FltDOi1kNcrDy2Ue1usWg9ofso4OkrCF97HOClU8/6D4QxD2KT0AOBECszHpPFu9nNCV0zQqoNGP1jMUo1nO8oDgR5EFKSFeBmMagEFvPr3n5GbI5ixnkmACuIjH935yWs91Hc2pJCYYUkhKRFYBp7kGQSg/8OSvPlO8pWE6XyDMSBWM0p3X9mLkG+cjTx6ySVuFcv8Cx3IOwT9HZ08P0jZETlBsE+eAOOJZf7Lph4GcLJ9mxM91dMr6UNAly+M7M0rHoNhy5VVN9H6Nfajkwv2nBOnenxtVovpdwTbq3ly/WvsVH7+Nbv9zQFghmCOEAAAAASUVORK5CYII=) 100% 100% no-repeat;
  }

  .card-work-link-msg {
    max-width: 360px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .work-link-to-icon {
    position: absolute;
    display: inline-block;
    transform: translateY(-50%);
    top: 50%;
    right: 8px;
    width: 12px;
    height: 12px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAoUlEQVQoU2NkQAabfbm4mTj4vnqvfoEijsRhRJbg2Ra9/z8Dg8V/Rqbgb56Lt2HThK6hn4GBoeA/w/+f/xmZg7BpQtHA8J+BkXt79BxGBoak/4wMP/4zMQR9c1+6HdkmVA0gGQKaMDVg0cT4n8H4i9fSayAp3Bp2Rs9h/AdxGn4NJDmJVE/zbo3p+8/4v5DoYOXZFrP3P8N/K6IjjoGIpAEAiKliDZrIgE8AAAAASUVORK5CYII=) 100% 100% no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/components/Publishneiru.vue